import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';

const ConnectionIssueOverlay = () => {
  const [counter, setCounter] = useState(59);

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [counter]);

  return (
    <div className={styles.overlay}>
      <div className={styles.message}>
        <p>Connection lost {counter} </p>
      </div>
    </div>
  );
};

export default ConnectionIssueOverlay;
